import * as fromActions from './actions/types'


const reducer = (state, action) => {
  switch (action.type) {
    // to reset all flags on page load
    case fromActions.RESET:
      return resetFlags(state)

    // Fetch Service Booking
    case fromActions.FETCH_SERVICE_BOOKING:
      return updateFlags(state, { fetchServiceBooking: 'processing' })
    case fromActions.FETCH_SERVICE_BOOKING_FULFILLED: {
      state.relatedServiceBooking = action.payload
      return updateFlags(state, { fetchServiceBooking: 'processed' })
    }
    case fromActions.FETCH_SERVICE_BOOKING_ERROR:
      return onUpdateError(state, action, { fetchServiceBooking: 'error' })

    // Add Service Booking
    case fromActions.ADD_SERVICE_BOOKING:
      return resetFlags(state, { addServiceBooking: 'processing' })
    case fromActions.ADD_SERVICE_BOOKING_FULFILLED:
      return onUpdateFulfilled(state, action, { addServiceBooking: 'processed' }, { addServiceBooking: 'error' }, 'You have successfully indicated a service has been booked for your vehicle.', 'Add service booking request failed.')
    case fromActions.ADD_SERVICE_BOOKING_ERROR:
      return onUpdateError(state, action, { addServiceBooking: 'error' }, 'Add service booking request failed.')

    // Cancel Service Booking
    case fromActions.CANCEL_SERVICE_BOOKING:
      return resetFlags(state, { cancelServiceBooking: 'processing' })
    case fromActions.CANCEL_SERVICE_BOOKING_FULFILLED:
      return onUpdateFulfilled(state, action, { cancelServiceBooking: 'processed' }, { cancelServiceBooking: 'error' }, 'Your service booking request has been successfully cancelled.', 'Cancel service booking request failed.')
    case fromActions.CANCEL_SERVICE_BOOKING_ERROR:
      return onUpdateError(state, action, { cancelServiceBooking: 'error' }, 'Cancel service booking request failed.')

    // Submit Service Record
    case fromActions.SUBMIT_SERVICE_RECORD:
      return resetFlags(state, { submitServiceRecord: 'processing' })
    case fromActions.SUBMIT_SERVICE_RECORD_FULFILLED:
      return onUpdateFulfilled(state, action, { submitServiceRecord: 'processed' }, { submitServiceRecord: 'error' }, 'You have successfully updated your service record.', 'Updating service record failed.')
    case fromActions.SUBMIT_SERVICE_RECORD_ERROR:
      return onUpdateError(state, action, { submitServiceRecord: 'error' }, 'Updating service record failed.')

    // Complete Service Booking
    case fromActions.COMPLETE_SERVICE_BOOKING:
      return resetFlags(state, { completeServiceBooking: 'processing' })
    case fromActions.COMPLETE_SERVICE_BOOKING_FULFILLED:
      return onUpdateFulfilled(state, action, { completeServiceBooking: 'processed' }, { completeServiceBooking: 'error' }, 'Your service booking request has been successfully completed.', 'Updating service booking record failed.')
    case fromActions.COMPLETE_SERVICE_BOOKING_ERROR:
      return onUpdateError(state, action, { completeServiceBooking: 'error' }, 'Updating service booking record failed.')
    default:
      return state
  }
}

const onUpdateError = (state, { payload }, flags, errorMessage) => {
  const error = payload
  const serverMessage =
    typeof error === 'object' && error !== null
      ? error?.apiResponse?.message || error?.message || ''
      : ''

  state.apiResponse = serverMessage || errorMessage || ''
  return updateFlags(state, flags)
}

const onUpdateFulfilled = (state, { payload }, successFlags, errorFlags, successMessage, errorMessage) => {
  const isSuccess = payload?.apiResponse?.success !== false
  state.apiResponse = isSuccess
    ? successMessage
    : payload?.apiResponse?.message || errorMessage

  return updateFlags(state, isSuccess ? successFlags : errorFlags)
}

const updateFlags = (state, flags) => ({
  ...state,
  flags: { ...state.flags, ...flags }
})

const resetFlags = (state, flags) => ({
  ...state,
  apiResponse: null,
  flags: {
    ...state.flags,
    fetchServiceBooking: 'none',
    addServiceBooking: 'none',
    cancelServiceBooking: 'none',
    completeServiceBooking: 'none',
    submitServiceRecord: 'none',
    ...flags,
  },
})

export default reducer
